import { render, staticRenderFns } from "./AccordionFooter.vue?vue&type=template&id=21060184&scoped=true"
import script from "./AccordionFooter.vue?vue&type=script&lang=ts"
export * from "./AccordionFooter.vue?vue&type=script&lang=ts"
import style0 from "./AccordionFooter.vue?vue&type=style&index=0&id=21060184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21060184",
  null
  
)

export default component.exports